<template>
    <div class="app-footer">
        Made with Vue by Vinnie
    </div>    
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style>
.app-footer{
    height: 30px;
    line-height: 30px;
    color: #fff;
    background: #000000;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>

